import { SEPARATOR__horizontal_dashed } from '@/pages/_base/separators/SEPARATOR__horizontal_dashed';
import { FIELD_PRIMITIVE__seed } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__seed';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_BUTTON__seed_hide_input } from './buttons/G_BUTTON__seed_hide_input';
import { G_INPUT__seed } from './G_INPUT__seed';
import { G_SLIDER__seed } from './G_SLIDER__seed';
import { G_LIST__seed } from './list/G_LIST__seed';

interface PROPS {
  field: FIELD_PRIMITIVE__seed;
}

export function G_UI_FIELD__seed_master({ field }: PROPS) {
  /*
   *
   */

  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <div className="flex flex-col" {...{ onMouseOver, onMouseLeave }}>
      {/* ACTIONS */}
      <G_UI_FIELD__header {...{ field }}>
        <G_BUTTON__seed_hide_input />
      </G_UI_FIELD__header>

      <G_INPUT__seed {...{ field }} />

      <SEPARATOR__horizontal_dashed />

      <G_SLIDER__seed {...{ field }} />

      <SEPARATOR__horizontal_dashed />

      <G_LIST__seed {...{ field }} />
    </div>
  );
}
